module.exports = __webpack_public_path__ + "img/diorAddict2.00905e12.jpg";